import React, { useEffect } from "react";
//import Scss
import "assets/scss/themes.scss";
import './input.css'
import './layout-modern.css'
import './contract-flow-theme.css'
import './tabs-global.css'
import './badges-global.css'
//imoprt Route
import Route from "Routes/Index";
import { useDispatch } from "react-redux";
import { isTokenExpire } from "./slices/thunk";
import { TourProvider } from "@reactour/tour";
import { useTranslation } from "react-i18next";
import { GoogleOAuthProvider } from "@react-oauth/google";
// Activating fake backend

const App = (props: any) => {
  const dispatch: any = useDispatch();
  const {t} = useTranslation()
  const token = window.localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      dispatch(isTokenExpire());
      
    }
  }, [dispatch,token]);

  const steps = [
    {
      selector: ".step-1",
      content: t("Click here to create a new contract.") ,
    },
    {
      selector: ".step-2",
      content:t("This is your contract list.",) 
    },
    {
      selector: ".step-3",
      content: t( "Here you can fill project details")
    },
    
  ];
  
  return (
    <React.Fragment>
      <TourProvider styles={{
    popover: (base) => ({
      ...base,
      backgroundColor: "var(--app-surface)",
      color: "var(--app-text)",
      border: "1px solid var(--app-border)",
      borderRadius: "10px",
      padding: "15px",
      paddingTop:50,
      marginLeft:10
    }),
    arrow: (base) => ({
      ...base,
      color: "var(--app-text)",
    }),
    close: (base) => ({
      ...base,
      color: "red",          // Change icon color
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Add shadow
      "&:hover": {
        backgroundColor: "darkred",
      },
    }),
  }}
   steps={steps}
   >
          <GoogleOAuthProvider clientId="197058203624-r7q17crg22a6ujakri95h0vkjihv2grs.apps.googleusercontent.com">
      <Route />
      </GoogleOAuthProvider>
      </TourProvider>
    </React.Fragment>
  );
};

export default App;
